<template>
  <div class="video">
    <div class="video_return" @click="clickReturn">
      <img src="../../assets/img/pc/return.png" alt="" />
    </div>
    <div class="video_content">
      <div class="video_content_left">
        <div class="video_content_left_title">
          {{ videoList[videoIndex] ? videoList[videoIndex].name : '' }}
        </div>
        <video
          controls
          :src="videoList[videoIndex] ? videoList[videoIndex].videoIntro : ''"
          :poster="
            videoList[videoIndex] ? videoList[videoIndex].videoCoverImgUrl : ''
          "
        ></video>
      </div>
      <div class="video_content_right">
        <div class="video_content_right_title">视频列表</div>
        <div
          class="video_content_right_item"
          v-for="(item, index) in videoList"
          :key="index"
          @click="videoClick(index)"
        >
          <div class="video_content_right_item_pic">
            <img :src="item.videoCoverImgUrl" alt="" />
          </div>
          <div class="video_content_right_item_title">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['videoList'],
  data() {
    return {
      videoIndex: 0,
    }
  },
  methods: {
    clickReturn() {
      this.$emit('return')
    },
    videoClick(index) {
      // this.videoIntro = url
      // this.videoPlayerShow = true
      // this.$emit('videoPaly')
      this.videoIndex = index
    },
  },
}
</script>
<style lang="scss">
@import '../../assets/css/pc.scss';
.video {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9;
  background: #eee;
  .video_return {
    cursor: pointer;
    width: rem(158);
    height: rem(85);
    position: absolute;
    left: rem(40);
    top: rem(40);
    z-index: 9;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .video_content {
    width: 100%;
    height: 100%;
    display: flex;
  }
  .video_content_left {
    flex-grow: 1;
    height: 100%;
    background: rgba(44, 46, 50, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    video {
      width: rem(1566);
      height: rem(880);
      margin-top: rem(100);
      border-radius: 8px;
    }
  }
  .video_content_left_title {
    position: absolute;
    top: rem(80);
    left: 50%;
    transform: translateX(-50%);
    font-size: rem(28);
    color: #fff;
    text-align: center;
  }
  .video_content_right {
    width: rem(360);
    height: 100%;
    overflow-y: scroll;
    background: linear-gradient(136deg, #202021 0%, #1d1d1e 100%);
    padding-top: rem(150);
    padding-bottom: rem(50);
    box-sizing: border-box;
    position: relative;
    &::-webkit-scrollbar-track {
      // background: red;
    }
    &::-webkit-scrollbar-thumb {
      // background: red;
      background: rgba(252, 252, 252, 1);
      border-radius: 5px;
    }
    &::-webkit-scrollbar {
      background-color: rgba(0, 0, 0, 0);
      width: 5px;
      border-radius: 10px;
    }
  }
  .video_content_right_title {
    position: absolute;
    top: rem(80);
    left: 50%;
    transform: translateX(-50%);
    font-size: rem(20);
    color: #fff;
  }
  .video_content_right_item {
    width: rem(280);
    height: rem(186);
    margin: 0 auto;
    background: rgb(56, 56, 56);
    padding: rem(5);
    box-sizing: border-box;
    margin-bottom: rem(30);
  }
  .video_content_right_item_pic {
    width: 100%;
    height: rem(146);
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .video_content_right_item_title {
    color: #fff;
    margin-top: rem(5);
    font-size: rem(12);
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
